import React, { Component } from 'react';
import Calendar from './calendar';
import Attendance from './attendance';
import IncompleteWorkingDays from './incompleteAttendance';
import AttendanceSummary from './attendanceSummary'
import { getDashboardData, getCalendarDataAll, getEmployeeAttendanceSummary } from '../../actions/dashboardActions'
import { pushEventData } from '../../actions/index'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasAllCalendarData: false
        }
        this.pushEventData = this.pushEventData.bind(this);
    }

    componentDidMount() {
        if (window.parent && window.parent.pushSignalRData) {
            window.parent.pushSignalRData(this.pushEventData);
        }
    }

    pushEventData(eventData, eventType) {
        switch (eventType) {
            case 'OutTime':
                //this.props.pushEventData(eventData, eventType);
                this.props.getEmployeeAttendanceSummary();
                break;
            default:
                break;
        }
    }

    refreshData = () => {
        this.props.getEmployeeAttendanceSummary();
    }

    onNavigate = () => {
        if (!this.state.hasAllCalendarData) {
            this.props.getCalendarDataAll();
            this.setState({ hasAllCalendarData: true })
        }
    }

    render() {

        const incompleteAttendance = this.props.dashboardData.incompleteAttendance;
        const employeeAttendanceSummary = this.props.dashboardData.employeeAttendanceSummary;
        const isAdmin = this.props.dashboardData.userRole === "Admin";
        return (
            <div>
                <div className="row" style={{ display: 'flex', margin: '15px 2px 2px 2px' }} >
                    <div className="col-lg-4 col-md-12 col-sm-12">
                        <h3>Attendance</h3>
                        <Attendance attendance={this.props.attendance} />
                        {//isAdmin &&
                            <div className='pt-4'>
                                <div className='row'><div className='col-md-10'><h3>Team</h3></div>
                                    <div className='col-md-2'><input type="button" onClick={this.refreshData} value="Refresh" /></div>
                                </div>
                                <AttendanceSummary employeeAttendanceSummary={employeeAttendanceSummary} />
                            </div>
                        }
                        {!isAdmin && (incompleteAttendance && incompleteAttendance.length > 0) &&
                            <div className='pt-4' style={{ width: '100%' }}>
                                <h3>Incomplete Attendance</h3>
                                <IncompleteWorkingDays incompleteAttendance={incompleteAttendance} />
                            </div>
                        }
                    </div>
                    <div className="col-lg-8 col-md-12 col-sm-12">
                        <h3>Calendar</h3>
                        <Calendar events={this.props.dashboardData.calendar} onNavigate={this.onNavigate} />
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        employeeAttendanceSummary: state.dashboardData.employeeAttendanceSummary,
        calendar: state.dashboardData.calendar
    }
}
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ getDashboardData, getCalendarDataAll, getEmployeeAttendanceSummary, pushEventData }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);


